import {
  AccountOrCardVerification,
  NewPassword,
  OtpVerification,
  UsernameVerification,
} from "@/modules/auth/components";
import { resetResetFields, setChallenge, } from "@/modules/auth/state";
import { Challenge } from "@/shared/common/enums";
import { NotFound, Notification } from "@/shared/components";
import { useAppDispatch, useAppSelector, useNotify } from "@/shared/hooks";
import { Heading } from "@ab.uitools/ui-library/components/Heading";
import { type ReactNode, useEffect } from "react";
import { useTranslation } from "react-i18next";

interface ITemplate {
  [key: string]: ReactNode | null;
}

export const Reset = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { clearAlertNotification } = useNotify();

  const challenge = useAppSelector((state) => state.auth.challenge);

  const Template: ITemplate = {
    [Challenge.Empty]: <AccountOrCardVerification/>,
    [Challenge.RequireUsername]: <UsernameVerification/>,
    [Challenge.SmsVerificationRequired]: <OtpVerification isReset/>,
    [Challenge.PasswordReset]: <NewPassword/>,
  };

  useEffect(() => {
    return () => {
      dispatch(setChallenge(""));
      dispatch(resetResetFields());
    };
  }, []);

  useEffect(() => {
    clearAlertNotification();
  }, [challenge]);

  return (
    <div className="auth">
      <div
        className="card flexbox flex-direction--column align-items--center full-width pt-48 pb-48 pl-48 pr-48"
      >
        <Heading
          className="mr-12 reset-title"
          size="xsmall"
          weight="bold"
          lineHeight="small"
        >
          {t("auth.reset.title")}
        </Heading>
        <Notification className="mt-28 full-width"/>
        {Template[challenge as string] || <NotFound/>}
      </div>
    </div>
  );
};
